module.exports = __webpack_public_path__ + "static/media/hmatic.2ab9e2aa.png";